import styled from 'styled-components'

export const Body = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .MuiDivider-root {
    width: 100%;
  }
`

export const ColumnFlexCenter = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 4px;
`

export const InfoBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 16px;
`
